jQuery(function($){
  var videoPlayer = {
    init: function(){
      if ($('.video').length){
        videoPlayer.initVideo();
      }
    },
    loadYTApi: function(videoId){
      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },
    initVideo: function(){
      $('.video').each(function(){
        var $videoBtn = $(this).find('[data-ref="video-player-trigger"]');
        var $videoMask = $(this).find('.video__mask');
        var ytRegexp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        var videoId = ytRegexp.exec($(this).data('vid-src'))[1];
        videoPlayer.loadYTApi(videoId);
        $videoBtn.on( 'click', function(){
          var player = new YT.Player('yt-player', {
            height: '360',
            width: '640',
            videoId: videoId,
            events: {'onReady' : videoPlayer.onPlayerReady }
          });
          setTimeout(function() {
            $videoMask.addClass('hide');
            $('iframe#yt-player')[0].playVideo();
          }, 300);
          setTimeout(function() {
            $videoMask.addClass('disable');
          }, 600);
        });
      });
    },
    onPlayerReady: function(event){
      event.target.playVideo();
    }
  };
  videoPlayer.init();
});
